/**
 * Payment and payout-related types
 */

// Payout status enum - used in Payment and Payout interfaces
export enum PayoutStatusType {
  PENDING = "pending",
  PAID = "paid",
}

// Assigned ticket within a payment
export interface AssignedTicket {
  ticketId: string;
  title: string;
  attendeeId?: string;
  attendeeFirstname?: string;
  attendeeLastname?: string;
  taken: boolean;
}

export interface Payment {
  id: string;
  createdAt: string;
  payoutAt?: string;
  payoutStatus: PayoutStatusType;
  eventId: string;
  eventTitle: string;
  assignedTickets: AssignedTicket[];
  payerName: string;
  amount: number;
  fees: number;
  netAmount: number;
  currency: string;
  quantity: number;
  paymentMethod: string;
  invoiceNumber?: string;
  invoiceLink?: string;
  actions: string[];
}

// Payout item returned from API
export interface Payout {
  id?: string;
  eventId: string;
  eventTitle: string;
  payoutStatus: PayoutStatusType;
  ticketsCount: number;
  collectedAmount: number;
  paidOutNetAmount: number;
  payoutDue: string | null;
  paidOutInvoiceId?: string;
  paidOutInvoiceLink?: string;
  feesPaymentProviderAmount: number;
  feesMedenticAmount: number;
  fees: number;
  feesInvoiceId?: string;
  feesInvoiceLink?: string;
  currency: string;
  note?: string;
  createdAt?: string;
  updatedAt?: string;
}

// Pending totals summary for payouts
export interface PendingTotals {
  paidOutNetAmount: number;
  collectedAmount: number;
  fees: number;
  ticketsCount: number;
  currency: string;
}

// Full payouts API response structure
export interface PayoutsResponse {
  payouts: Payout[];
  pendingTotals: PendingTotals | null;
}
